import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddClientConn = (props) => {
  const [clients, setClients] = useState([]);
  const [clientsSygn, setClientsSygn] = useState([]);
  const [client, setClient] = useState([]);
  const [clientId, setClientId] = useState([]);
  const [loading, setLoading] = useState([]);
  const [clientsOptions, setClientsOptions] = useState([]);

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data).filter((el) => el.arch === "0");
        setClients(data);
        setClientsOptions(createClientsOptions(data));
      })
      .catch((error) => {});
  };

  const fetchClientsAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data).filter((el) => el.arch === "0");
        setClients(data);
        setClientsOptions(createClientsOptions(data));
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    if (props.team === 0) {
      fetchClientsAll();
    } else {
      fetchClients();
    }

    fetchClientsSygn();
  };

  useEffect(() => {
    getData();
  }, []);

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label:
          el.petitioner +
          " | " +
          (data.filter((el2) => el2.id === el.id)[0].aSygn === "brak danych"
            ? el.credit_value
            : data.filter((el2) => el2.id === el.id)[0].aSygn),
        value: el.id,
      });
    });
    return bankOptions;
  };

  const handleClientChange = (e) => {
    setClient(clients.filter((el) => +el.id === +e.value)[0]);
    setClientId(e.value);
  };

  const addConn = async (e) => {
    if (client) {
      setLoading(true);

      var body = {
        clientId: clientId,
        id: props.id,
      };

      var url = "";

      if (props.place === "hearing") {
        url = "https://apidevkppp.ftpeople.pl/addClientHearing";
      }
      if (props.place === "task") {
        url = "https://apidevkppp.ftpeople.pl/addClientTask";
      }
      if (props.place === "payment") {
        url = "https://apidevkppp.ftpeople.pl/addClientPayment2";
      }
      if (props.place === "paymentA") {
        url = "https://apidevkppp.ftpeople.pl/addClientPayment3";
      }

      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          if (props.place === "payment") {
            var body2 = {
              id: clientId,
              mail: props.mail,
              phone: props.phone,
            };

            fetch("https://apidevkppp.ftpeople.pl/setClientBasicContactData", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          }
        })
        .catch((error) => {});

      MySwal.fire({
        icon: "success",
        title: "Powiązano",
        text: "rekord z klientem",
      }).then((result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  return (
    <>
      <div className="mainContainerAddSygn">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeButtonAP">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div style={{ width: "100%" }} className="inputBox">
              <div className="inputCol_1">
                <label>
                  Klient <span className="requiredStar">*</span>
                </label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  options={clientsOptions}
                  onChange={handleClientChange}
                />
              </div>
            </div>
            <div className="acceptButtonContainer">
              <button className="acceptButton" onClick={addConn}>
                POWIĄŻ
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddClientConn;
